module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-3.f4ecbbba.jpg";